<template>
  <div
    class="menu_footer nav nav-pills"
  >
    <div
      class="menu_footer_item nav-link"
      :class="{ active: currentRouteName == ROUTE_INDEX }"
      data-bs-toggle="pill"
      @click="goTo(ROUTE_INDEX)"
    >
      <div
        class="img-icon"
        :class="{
          'img-icon-default': isDefaultSite,
          'img-icon-cc': isChokCharoen,
          'img-icon-jj': isJertjarat,
          'img-icon-bc': isBooncharern,
        }"
      >
        <img
          v-if="isDefaultSite"
          src="@/assets/v3/nav-menu/default/home.png"
        />
        <img
          v-else-if="isChokCharoen"
          src="@/assets/v3/nav-menu/cc/home.png"
        />
        <img
          v-else-if="isJertjarat"
          src="@/assets/v3/nav-menu/jj/home.png"
        />
        <img
          v-else-if="isBooncharern"
          src="@/assets/v3/nav-menu/bc/home.png"
        />
        <img 
          v-else
          src="@/assets/v3/icon-home.png"
        />
      </div>
      <p class="">
        {{ $t('homepage') }}
      </p>
    </div>
    <div
      class="menu_footer_item nav-link"
      :class="{ active: currentRouteName == ROUTE_INTERNAL_LOTTO }"
      data-bs-toggle="pill"
      @click="goTo(ROUTE_INTERNAL_LOTTO)"
    >
      <div
        class="img-icon"
        :class="{
          'img-icon-default': isDefaultSite,
          'img-icon-cc-extra': isChokCharoen,
          'img-icon-jj': isJertjarat,
          'img-icon-bc': isBooncharern,
        }"
      >
        <img
          v-if="isDefaultSite"
          src="@/assets/v3/nav-menu/default/play.png"
        />
        <img
          v-else-if="isChokCharoen"
          src="@/assets/v3/nav-menu/cc/play.png"
        />
        <img
          v-else-if="isJertjarat"
          src="@/assets/v3/nav-menu/jj/play.png"
        />
        <img
          v-else-if="isBooncharern"
          src="@/assets/v3/nav-menu/bc/play.png"
        />
        <img 
          v-else
          src="@/assets/v3/icon-huay.png"
        />
      </div>
      <p class="">
        {{ $t('bet-lotto') }}
      </p>
    </div>
    <div
      class="menu_footer_item nav-link"
      :class="{ active: currentRouteName == ROUTE_DEPOSIT }"
      data-bs-toggle="pill"
      @click="goTo(ROUTE_DEPOSIT)"
    >
      <div
        class="img-icon"
        :class="{
          'img-icon-default': isDefaultSite,
          'img-icon-cc': isChokCharoen,
          'img-icon-jj-extra': isJertjarat,
          'img-icon-bc': isBooncharern,
        }"
      >
        <img />
        <img
          v-if="isDefaultSite"
          src="@/assets/v3/nav-menu/default/deposit.png"
        />
        <img
          v-else-if="isChokCharoen"
          src="@/assets/v3/nav-menu/cc/deposit.png"
        />
        <img
          v-else-if="isJertjarat"
          src="@/assets/v3/nav-menu/jj/deposit.png"
        />
        <img
          v-else-if="isBooncharern"
          src="@/assets/v3/nav-menu/bc/deposit.png"
        />
        <img 
          v-else
          src="@/assets/v3/icon-depos.png"
        />
      </div>
      <p class="">
        {{ $t('deposit-money') }}
      </p>
    </div>
    <div
      class="menu_footer_item nav-link"
      :class="{ active: currentRouteName == ROUTE_CONTACT }"
      data-bs-toggle="pill"
      @click="goTo(ROUTE_CONTACT)"
    >
      <div
        class="img-icon"
        :class="{
          'img-icon-default': isDefaultSite,
          'img-icon-cc': isChokCharoen,
          'img-icon-jj': isJertjarat,
          'img-icon-bc': isBooncharern,
        }"
      >
        <img
          v-if="isDefaultSite"
          src="@/assets/v3/icon-e.png"
        />
        <img
          v-else-if="isChokCharoen"
          src="@/assets/v3/nav-menu/cc/support.png"
        />
        <img
          v-else-if="isJertjarat"
          src="@/assets/v3/nav-menu/jj/support.png"
        />
        <img
          v-else-if="isBooncharern"
          src="@/assets/v3/nav-menu/bc/support.png"
        />
        <img 
          v-else
          src="@/assets/v3/icon-contact.png"
        />
      </div>
      <p class="">
        {{ $t('contact') }}
      </p>
    </div>
    <dialog-contact-agent ref="dialogContactAgent" />
  </div>
</template>
<script> 
import { ROUTE_INDEX, ROUTE_INTERNAL_LOTTO, ROUTE_DEPOSIT, ROUTE_CONTACT } from '@/const/route'
import dialogContactAgent from '@/components/Dialog/DialogContactAgent'

export default {
  components: {
    dialogContactAgent
  },
  data: () => ({
  }),
  computed : {
    ROUTE_INDEX: () => ROUTE_INDEX,
    ROUTE_DEPOSIT: () => ROUTE_DEPOSIT,
    ROUTE_INTERNAL_LOTTO: () => ROUTE_INTERNAL_LOTTO,
    ROUTE_CONTACT: () => ROUTE_CONTACT,
    currentRouteName () {
      return this.$route.name;
    }
  },
  methods: {
    goTo (name) { 

      if (name == ROUTE_CONTACT) {
        this.$refs.dialogContactAgent.open()
        return
      }

      this.$router.push({ name }).catch(()=>{}); 
    },
  }
}

</script>

<style scoped>
.menu_footer {
  width: 100%;
  height: 65px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9;
  display: flex;
  flex-wrap: nowrap !important;
  align-items: flex-end;
  background: linear-gradient(100deg, var(--v3-footer-color-10) 0%, var(--v3-footer-color-15) 100%);
}
.menu_footer .menu_footer_item {
  width: 25%;
  text-align: center;
  color: #fff;
  padding: 0;
  font-size: 16px;
}

.img-icon-default {
  width: 58px !important;
}

.img-icon-cc {
  width: 48px !important;
}

.img-icon-cc-extra {
  width: 60px !important;
}

.img-icon-jj {
  width: 70px !important;
}

.img-icon-jj-extra {
  width: 80px !important;
}

.img-icon-bc {
  width: 48px !important;
}



.menu_footer .menu_footer_item .img-icon {
  width: 50px;
  margin: 0 auto;
}

.menu_footer .menu_footer_item .img-icon img {
  transition: all 0.3s;
}
.menu_footer .menu_footer_item p {
  padding: 3px 0;
  transition: all 0.3s;
  color: #fff;
}
.menu_footer .menu_footer_item.active {
  background-color: rgba(0, 0, 0, 0) !important;
}
.menu_footer .menu_footer_item.active .img-icon img {
  transform: scale(1.2);
}
.menu_footer .menu_footer_item.active p {
  transform: scale(1.1);
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
  color: #0d6efd;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
.nav-link:hover {
  cursor: pointer;
  transform: scale(1.05);
}

img {
  width: 100%;
}
p {
  margin-bottom: 0;
}
</style>
